export default __webpack_public_path__ + "static/media/4cc8f5da-4e24-4929-8efb-866ffcb1fe7e.1f0dd630.eot";